var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[(_vm.$store.state.username)?_c('header',[_c('h1',[_vm._v("Welcome to Curator Central, @"+_vm._s(_vm.$store.state.username)+"!")])]):_c('Welcome'),(_vm.$store.state.username)?_c('Gallery',{attrs:{"works":_vm.allWorks,"showRemoveWork":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }